import { LoginFormValues } from '@porterin/booking-flow/src/auth/domain/validations/LoginValidationSchema';
import { useAuthContentContext } from '@porterin/booking-flow/src/auth/view/contexts/auth-content/AuthContentContext';
import { publishAuthCtaTapEvents } from '@porterin/booking-flow/src/auth/view/helpers/AuthAnalyticsHelper';
import { GaEvents } from '@porterin/booking-flow/src/auth/view/stores/AuthAnalyticsStore';
import { PrefillData } from '@porterin/booking-flow/src/auth/view/types/SignupModal';
import { mapPageToCategory } from '@porterin/booking-flow/src/utils/BookingFlowAnalyticsHelper';
import { TextInput, Button } from '@porterin/component-library/src';
import Image from 'next/image';
import { Dispatch, SetStateAction } from 'react';
import { UseFormReturn } from 'react-hook-form';

import Declaration from '../common/Declaration';

export interface LoginFormProps {
  form: UseFormReturn<LoginFormValues>;
  on_submit: (data: LoginFormValues) => Promise<void>;
  set_is_mobile_updated: Dispatch<SetStateAction<boolean>>;
  prefill_data: PrefillData | null;
}

const LoginFormFields: React.FC<LoginFormProps> = ({
  form,
  on_submit,
  set_is_mobile_updated,
  prefill_data,
}) => {
  const { loginModal } = useAuthContentContext();
  const {
    register,
    getValues,
    handleSubmit,
    formState: { errors },
  } = form;

  return (
    <form
      onSubmit={handleSubmit(on_submit)}
      className="flex flex-col mt-[3rem] max-lg:mt-[2.4rem] w-full lg:justify-between h-full"
    >
      <div className="flex flex-col space-y-6 sm:justify-between">
        <TextInput
          className="text-text-lg font-normal"
          icons={{
            leftIcon: (
              <Image
                src={loginModal.phoneField.icon.path}
                height={16}
                width={16}
                alt={loginModal.phoneField.icon.altText}
              />
            ),
          }}
          identifiers={{ id: 'phone' }}
          inputOptions={{
            placeholder: loginModal.phoneField.placeholder,
            error: errors.phone?.message,
          }}
          autoFocus={true}
          {...register('phone', {
            onChange: e => {
              set_is_mobile_updated(e.target.value != prefill_data?.mobile);
            },
          })}
        />
      </div>

      <div className="flex flex-col sm:flex-col-reverse sm:align-end relative max-lg:mt-[2rem]">
        <Button
          className="bg-[#0A57FF] text-typography-primary-inverse font-copy-lg font-semibold sm:mt-3"
          identifiers={{ id: 'login' }}
          interactions={{
            onClick: () => {
              publishAuthCtaTapEvents(
                mapPageToCategory(window.location.pathname),
                GaEvents.formSubmit.login,
                'login',
                getValues('phone'),
              );
            },
          }}
        >
          {loginModal.submitCta}
        </Button>
        {errors.root?.message && (
          <div className="text-[#eb5757] text-lg font-semibold whitespace-nowrap absolute sm:bottom-0 top-0 sm:translate-y-full -translate-y-full">
            {errors.root?.message}
          </div>
        )}
        <Declaration agreement_policy={loginModal.agreementPolicy} />
      </div>
    </form>
  );
};

export default LoginFormFields;
